import {
  Component,
  HostBinding,
  Input,
  OnInit,
  forwardRef
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { TOOLTIP_COLOR } from './TooltipColor.enum';
import { TOOLTIP_POSITION } from './TooltipPosition.enum';

@Component({
  selector: 'ls-tooltip',
  templateUrl: './tooltip.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TooltipComponent),
      multi: true
    }
  ]
})
export class TooltipComponent implements OnInit {
  @HostBinding('class')
  public classes = 'tooltip__content tooltip__content--fixed';

  @Input()
  public color: string = TOOLTIP_COLOR.DARK;
  @Input()
  private position: string = TOOLTIP_POSITION.RIGHT;

  public ngOnInit(): void {
    if (this.position === undefined) {
      this.position = TOOLTIP_POSITION.RIGHT;
    }
    this.classes = `${this.classes} ${this.color} ${this.position}`;
  }
}
